<template>
  <b-card
    no-body
    class="h-100 m-0 p-0"
  >
    <b-card-header class="mx-0 px-0">
      <b-card-title class="mx-0 px-0">{{title}}</b-card-title>
    </b-card-header>

    <b-card-body
      :style="`max-height: ${height}`"
      class="overflow-auto mx-0 px-0"
    >
      <b-overlay :show="isLoading">
        <slot />
      </b-overlay>
    </b-card-body>
  </b-card>
</template>

<script>
import { $themeColors } from '@themeConfig'

export default {
  props: ['title', 'section', 'height'],
  data() {
    return {
      isLoading: false,
    }
  },

  watch: {
  },
  mounted() {
  },
  methods: {

  },
}
</script>
